<template>
  <!-- yhub app 设备周报 -->
  <div id="mainContent" class=" main_content">
    <div v-loading="loading" class="content-wrap" element-loading-text="…………" style="padding-bottom:20px;">

      <img v-if="isShowLogo" src="./gpd_logo.png" class="logo_img">

      <div class="top">
        <div class="top_title" style="font-size:24px;">{{ yhubInfo.deviceName }}</div>
        <div>{{$t('report.WeeklyReport')}}</div>
        <div class="dv1 flex_center flex_align_center">
          <div class="liner" />

          <!-- <el-select v-model="currentWeek" style="width: 280px;" @change="changeWeek">
            <el-option v-for="item in weekReport" :key="item.week" :value="item.week"
              :label="'第' + item.week + '周 ' + getDateAndHour(item.startTime, 'noTime') + '~' + getDateAndHour(item.endTime, 'noTime')">
            </el-option>
          </el-select> -->

            <el-date-picker
              ref="datePicker"
              v-model="currentWeek"
              type="week"
              :picker-options="{'firstDayOfWeek': 1}"
              @change="changeWeek">
            </el-date-picker>

          <div class="liner" />
        </div>

        <lang-select></lang-select>
        <div v-if="!isShowLogo" class="downBtn" @click="download"> <i class="el-icon-download"></i>PDF </div>
      </div>

      <!-- 设备状况 -->
      <div class="border">
        <div class="pane_title">
          <div class="bgBigDiv" />
          <div class="bgSmallDiv" />
          <div style="display: inline-block;">{{ $t('yhubReport.Machine') }}</div>
        </div>
        <div class="pane_content" style="padding-top: 10px;">
          <ul class="topdiv">
            <!-- <li class="lidiv" :style='bgBlue'> -->
            <li class="lidiv">
              <p class="leftcontent color1" />
              <div class="rightconment">
                <div class="right-tiltle">{{ yhubInfo.mechModel || '--' }}</div>
                <div class="rignt-percent">{{ $t('yhubReport.device_type') }}</div>
              </div>
            </li>
            <li class="lidiv">
              <p class="leftcontent color2" />
              <div class="rightconment">
                <div class="right-tiltle">{{ yhubInfo.deviceSn }}</div>
                <div class="rignt-percent">{{ $t("BondOrUpdateDevice.SN") }}</div>
              </div>
            </li>
            <li class="lidiv">
              <p class="leftcontent color3" />
              <div class="rightconment">
                <div class="right-tiltle">{{ yhubInfo.batteryBrand }}&nbsp;{{ yhubInfo.batteryModel }}</div>
                <div class="rignt-percent">{{ $t("BondOrUpdateDevice.BatteryInformation") }}</div>
              </div>
            </li>
            <li class="lidiv">
              <p class="leftcontent color4" />
              <div class="rightconment">
                <div class="right-tiltle">{{ yhubInfo.batteryCapacity || '--' }} Ah</div>
                <div class="rignt-percent">{{ $t("yhubReport.Capacity") }}</div>
              </div>
            </li>
            <li class="lidiv">
              <p class="leftcontent color5" />
              <div class="rightconment">
                <div class="right-tiltle">{{ handleDuration(yhubInfo.createTime) }}</div>
                <div class="rignt-percent">{{ $t("yhubReport.Duration") }}</div>
              </div>
            </li>
            <li class="lidiv">
              <p class="leftcontent color6" />
              <div class="rightconment">
                <div class="right-tiltle">{{ yhubInfo.batteryVoltage || '--' }} V</div>
                <div class="rignt-percent">{{ $t("basicinfo.SystemVoltage") }}</div>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <!-- 充放电记录 -->
      <div class="border" style="margin-top:15px;">
        <div class="pane_title">
          <div class="bgBigDiv" />
          <div class="bgSmallDiv" />
          <div style="display: inline-block;">{{ $t("yhubReport.chargeAndDischargeRecords") }}</div>
        </div>
        <div class="pane_content overhiden">

          <!-- 充电记录 -->
          <div
            style="position: relative;top: 546px;border: 1px solid #ebeef5;height: 40px;padding: 11px 0 0 10px;border-left: 5px solid #a9d252;color: black;border-radius: 4px 10px 0 0;background: #eff2f747;">
            {{ $t("yhubReport.Records") }}
          </div>
          <!-- 柱状折线图 -->

          <div class="chart-wrapper">
            <div id="chart2" class="chart" style="height:500px;width:100%;" />
            <!-- 导出时使用图片 -->
            <!-- <img id="chart3" style="width:100%;height:500px;display:none;"> -->
            <p v-show="columnLineNoData"
              style="text-align: center;line-height: 30px;top: 250px;position: absolute;width: 100%;">
              {{ $t("yhubReport.Nodata") }}</p>

          </div>

          <table border="1"
            style="width:100%;text-align: center;line-height: 33px;font-size: 14px;color: #606266;border-color: #bfccda;border-collapse:collapse;">
            <thead style="line-height: 40px;background: #eff2f7;border-bottom: 1px solid #bfccda;">
              <th> Cyc.# </th>
              <th>{{ $t('yhubReport.StartingTime') }}</th>
              <th>{{ $t('yhubReport.StartSOC') }}</th>
              <th>{{ $t('yhubReport.EndTime') }}</th>
              <th>{{ $t('yhubReport.EndSOC') }}</th>
              <th>{{ $t('yhubReport.ah') }}</th>
              <th>{{ $t('yhubReport.Duration') }}</th>
              <th>{{ $t('AllDevices.Status') }}</th>

              <!-- <th>{{ $t('yhubReport.Charts') }}</th> -->
            </thead>
            <tbody style="color: #324057;">
              <tr v-for="(item,index) in tableChargeData" :key="index">
                <td v-if="item.rowspan" :rowspan="item.rowspan">{{ item.cycles }}</td>
                <td>{{ item.startTime }}</td>
                <td>{{ Math.round(item.startSoc) }} %</td>
                <td>{{ item.endTime }}</td>
                <td>{{ Math.round(item.endSoc) }} %</td>
                <td>{{ item.energy }}</td>
                <td>{{ item.chargedTime }}</td>
                <td>{{ item.isChargeing? $t('basicinfo.Charged'):$t('basicinfo.DisCharged') }}</td>

              </tr>
            </tbody>
          </table>

        </div>
      </div>

      <!-- 设备情况摘要 -->
      <div class="border" style="margin-top:15px;">
        <div class="pane_title">
          <div class="bgBigDiv" />
          <div class="bgSmallDiv" />
          <div style="display: inline-block;">{{ $t('yhubReport.Dailystatistics') }}</div>
        </div>
        <!-- <div class="pane_content" style="border: 1px solid #F5F7FA;width:100%;overflow: auto;margin-top:10px;"> -->
        <div class="pane_content" style="border: 1px solid #F5F7FA;width:100%;margin-top:10px;margin-bottom:10px;">

          <table border="1"
            style="width:100%;text-align: center;line-height: 33px;font-size: 14px;color: #606266;border-color: #bfccda;border-collapse:collapse;">
            <thead style="line-height: 40px;background: #eff2f7;border-bottom: 1px solid #bfccda;">
              <th>{{ $t('yhubReport.Date') }}</th>
              <th>{{ $t('yhubReport.runtime_duration') }}</th>
              <th>{{ $t('yhubReport.usage_duration') }}</th>
              <th>{{ $t('yhubReport.Discharge') }}</th>
              <th>{{ $t('yhubReport.ChargingTime') }}</th>
              <th>{{ $t('yhubReport.Charge') }}</th>
              <th>{{ $t('yhubReport.MinimumSOC') }}</th>
              <th>{{ $t('yhubReport.MinimumVoltage') }}</th>
              <th>{{ $t('yhubReport.MaximumTemperature') }}</th>
            </thead>
            <tbody style="color: #324057;">
              <tr v-for="(item,index) in summaryList" :key="index">
                <td>{{ item.monthDay }}</td>

                <!-- <td>{{ parseInt((item.workTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) }} h
                  {{ parseInt((item.workTime % (1000 * 60 * 60)) / (60* 1000)) }} min </td>
                <td>{{ parseInt((item.usedTime% (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) }} h
                  {{ parseInt((item.usedTime% (1000 * 60 * 60)) / (60* 1000)) }} min </td> -->
                <td>{{getDuration(item.workTime)}}</td>
                <td>{{getDuration(item.usedTime)}}</td>
                <td>{{ Math.round(item.usedAh/100) }} Ah</td>
                <td>{{getDuration(item.chargeTime)}}</td>

                <!-- <td :title="item.chargeTime">
                  {{ parseInt((item.chargeTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) }} h
                  {{ parseInt((item.chargeTime % (1000 * 60 * 60)) / (60* 1000)) }} min </td> -->
                <td>{{ Math.round(item.charedAh/100) }} Ah</td>
                <td>{{ Math.round(item.minSoc/100) }} %</td>
                <td>{{ item.minVoltage/100 }} V</td>
                <td>{{ Math.floor(item.maxTemprature/100) }} ℃</td>
              </tr>
            </tbody>
          </table>
        </div>
        <el-table v-if="showTableCharts" border="" :data="summaryList" :row-class-name="rowIndex"
          style="width: 100%;margin-top: 10px;">
          <el-table-column prop="monthDay" width="100px" align="center" :label="$t('yhubReport.Date')" />

          <el-table-column prop="1" :label="$t('yhubReport.Charts')" align="center">
            <template scope="scope">
              <div class="pieChartDiv">
                <yhub-pie-chart class="myPieChartFirst" :series-data="scope.row.pieSeriesData1" :height="pieHeight"
                  :color-arr="colorArr1" />
                <yhub-pie-chart class="myPieChartSecond" :series-data="scope.row.pieSeriesData2" :height="pieHeight"
                  :color-arr="colorArr2" style="display:none;" />
              </div>
              <div style="position: absolute;text-align: left;bottom: 20px;width:100%;">
                <!-- 使用率、充放电比 -->
                <button class="changePieBtn firstBtn active"
                  @click="changePieChart($event,1,scope.$index)">{{ $t("yhubReport.UsageRate") }}</button>
                <button class="changePieBtn secondBtn"
                  @click="changePieChart($event,2,scope.$index)">{{ $t("yhubReport.chargeDischargeRatio") }}</button>
                <div class="el-icon-question" style="font-size:20px;" @mouseover="mouseoverQuestion(scope.$index)"
                  @mouseout="mouseoutQuestion(scope.$index)" />
                <!-- 选项卡处的问号弹窗 -->
                <div class="questionPop">
                  <p>{{ $t('yhubReport.DischargeInfo') }}</p>
                  <p>{{ $t('yhubReport.ChargeInfo') }}</p>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column max-width="50%" prop="" :label="$t('yhubReport.AHDistribution')" align="center">
            <template scope="scope">

              <yhubReportBarChart :height="pieHeight" :data-detail="scope.row.odcEventDailyVoList1" />

            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 警告 -->
      <div class="border" style="margin-top:15px;padding-bottom: 0">
        <div class="pane_title">
          <div class="bgBigDiv" />
          <div class="bgSmallDiv" />
          <div style="display: inline-block;">{{ $t('yhubReport.WarningMessage') }}</div>
        </div>
        <div class="pane_content overhiden">

          <table border="1"
            style="width:100%;text-align: center;line-height: 33px;font-size: 14px;color: #606266;border-color: #bfccda;border-collapse:collapse;">
            <thead style="line-height: 40px;background: #eff2f7;border-bottom: 1px solid #bfccda;">
              <th style="text-align:center;width:15%;">{{ $t('yhubReport.occurredAt') }}</th>
              <th style="text-align:center;width:30%;">{{ $t('warningPage.Content') }}</th>
              <th style="text-align:center;width:10%;">{{ $t('AllDevices.Status') }}</th>
              <th style="text-align:center;width:15%;">{{ $t('warningPage.SovledAt') }}</th>
              <th style="text-align:center;width:30%;">{{ $t('warningPage.Remark') }}</th>
            </thead>
            <tbody style="color: #324057;">
              <tr v-for="(item,index) in warningTableData" :key="index">
                <td>{{ item.createTime }}</td>
                <td>{{ item.message }}</td>
                <td>{{ item.status }}</td>
                <td>{{ item.updateTime }}</td>
                <td>{{ item.remark }}</td>
              </tr>
              <tr v-if="warningTableData.length==0">
                <td colspan="5">{{ $t('yhubReport.NoWarnings') }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>
    <!-- 公司详情 -->
    <div v-loading="loading" class="content-wrap" element-loading-text="…"
      style="padding-bottom:20px;min-height: 10px;margin-top: 15px;">
      <div class=" content" style="height:auto;padding: 0;">
        <div id="companyDetail" class="border" style="margin-top: 15px;background:white;">
          <div class="pane_title">
            <div class="bgBigDiv" />
            <div class="bgSmallDiv" />
            <div style="display: inline-block;">{{ $t("report.companyDetail") }}</div>
          </div>
          <div class="pane_content" style="line-height: 30px;font-size: 16px;padding: 10px 0 0 10px;">
            <p>{{ yhubInfo.companyName }}</p>
            <p>{{ yhubInfo.companyAddr }}</p>
            <p>{{ yhubInfo.companyEmail }}</p>
            <a :href="yhubInfo.companyUrl">
              <p>{{ yhubInfo.companyUrl }}</p>
            </a>
          </div>
        </div>
        <div id="contactUs" class="border" style="margin-top: 15px;background:white;">
          <div class="pane_title">
            <div class="bgBigDiv" />
            <div class="bgSmallDiv" />
            <div style="display: inline-block;">{{ $t("report.contactUs") }}</div>
          </div>
          <div class="pane_content" style="line-height: 30px;font-size: 16px;padding: 10px 0 0 10px;">
            <p style="margin:0;">{{ form1.email }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { reportDetail, getHourReport, getOdc, listChargingDischarging, listWarningPushMsg2 } from './weekReportEmailNew'
import { findBatteryDeviceWeekList } from '@/api/report.js'
import BarChartTwo from './BarChartTwo'
import yhubReportBarChart from '@/components/yhubReportBarChart'
import yhubPieChart from '@/components/yhubPieChart'
import { temChangeUnit } from '@/utils/temChange.js'
import { getDuration } from '@/utils'

import echarts from 'echarts'
import { getDateAndHour, getDateAndWeek } from '@/utils/updateTime.js'
import LangSelect from '@/components/LangSelect.vue'

import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'

const animationDuration = 6000

export default {
  components: {
    yhubReportBarChart,
    yhubPieChart,
    BarChartTwo,
    LangSelect
  },
  data () {
    return {
      getDuration,
      getDateAndHour,
      width: '100%',
      height: '200px',
      heightz: '300px',
      pieHeight: '200px',
      colorArr1: ['#a9d252', '#ff8c23', '#019ad6'],
      colorArr2: ['#e2c31d', '#33cccc'],
      loading: false,
      odcEventList: [],
      summaryList: [],
      dsl1: [],
      data: {},
      reportDetail: {},
      current: [],
      columnLineNoData: false,
      // form: { name: '云充科技', address: '深圳上梅林', website: 'http://www.gpdcloud.net', email: 'support@gpowerdesign.com' },
      form: {},
      weekStart: null,
      weekEnd: null,
      bgBlue: {
        // backgroundImage: 'url(' + require('@/assets/picture/backgroundBlue.png') + ') ',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
      },

      // 折线图
      dataSize: 0,
      chargedAh: 0.0,
      minSoc: 100,
      options: this.getOptionsLocal(),
      // timer: null,
      soc: 0, // 电池电量
      charging: -1, // 1.充电中、0.就绪、－1.放电中
      listLoading: true,
      showTime: null, // 显示的最后更新时间
      value: '2',
      // listQuery: {
      //   id: null,
      //   sn: null,
      //   startDate: null,
      //   endDate: null
      // },
      fullscreenLoading: false,

      tableData: [],
      myodcDailyVo: {},
      myPieChart: null,
      myPieChartFirstData: [],
      myPieChartSecondtData: [],
      recordList: [],
      odcDailyVoList: [],
      pieChartSecondShow: false,

      // 柱状折线图
      myDetailChart: null,
      myDetailOption: null,
      socData: [],
      screenWidth: document.body.clientWidth,
      pieWidth: '0',
      timer: null,
      tableChargeData: [],
      jlcgImgBase64: null,
      showTableCharts: true,
      form1: { email: 'support@gpowerdesign.com' },
      isShowLogo: false,
      printTime: null,
      warningTableData: [], // 警告表格
      weekReport: [],
      currentWeek: new Date().getTime(),
      yhubInfo: {},
      myChart2: null,
      weekObj: {}
    }
  },
  computed: {
    mcuId () {
      return this.$route.query.mcuId || ''
    },
    latest () {
      const time = this.$route.query.latest
      if (time) return time
      return new Date().getTime()
    },
    // weekObj () {
    //   const obj = this.weekReport.find(item => item.week == this.currentWeek)
    //   if (obj) return obj
    //   return {}
    // }
  },

  mounted () {
    this.myChart2 = echarts.init(document.getElementById('chart2'));
    this.myChart2.showLoading()


    setTimeout(() => {
      // this.getWeekList()
      this.getreportdetail()
      this.changeWeek()
    }, 1000);
    // 折线图
    // var startDay = new Date().getTime() - 7 * 24 * 60 * 60 * 1000
    // this.listQuery.startDate = new Date(startDay).getFullYear() + '-' + (new Date(startDay).getMonth() + 1) + '-' + new Date(startDay).getDate()
    // this.listQuery.endDate = new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate()
    // this.listQuery.id = this.$route.query.id

    // var timeZ = new Date().getTimezoneOffset() / 60
    // this.printTime = Number(this.latest) + (timeZ + 5) * 60 * 60 * 1000
    // this.weekStart = getDateAndHour(this.printTime - 7 * 24 * 60 * 60 * 1000, 'noTime')
    // this.weekEnd = getDateAndHour(this.printTime, 'noTime')


  },

  methods: {
    getWeekStartEndTimestamp(time) {
      const now = new Date(time);
      const day = now.getDay(); // 获取今天是周几，周日为0，周六为6
      const diff = now.getDate() - day + (day === 0 ? -6 : 1); // 根据今天是周几调整日期
      const date = new Date(now.setDate(diff)); // 设置日期为周一
      const startOfTheWeek = date.getTime(); // 周一的时间戳
      const endOfTheWeek = new Date(date.setDate(date.getDate() + 7)).getTime(); // 周日的时间戳

      this.weekObj.startTime = startOfTheWeek;
      this.weekObj.endTime = endOfTheWeek - 1000;
      console.log(this.weekObj)
      this.initChart2()
      this.listWarning2()
      this._getOdc()
    },
    changeWeek () {
      console.log(this.currentWeek)
      this.getWeekStartEndTimestamp(this.currentWeek)
      
    },
    // getWeekList () {
    //   findBatteryDeviceWeekList({
    //     key: this.mcuId
    //   }).then(res => {
    //     console.log('周报列表：', res)
    //     if (res.resultCode == 1001 && res.resultModel) {
    //       const list = res.resultModel.list
    //       if (list.length) {
    //         this.reportDetail = list[0]
    //         this.weekReport = list[0].weekReport
    //         this.currentWeek = this.weekReport[0] ? this.weekReport[0].week : 0
    //       }
    //       // else {
    //       //   this.getreportdetail()
    //       // }
    //     }

    //     this.initChart2()
    //     this.listWarning2()
    //     this._getOdc()

    //   })
    // },
    mouseoverQuestion (index) {
      document.querySelectorAll('.questionPop')[index].style.display = 'block'
    },
    mouseoutQuestion (index) {
      document.querySelectorAll('.questionPop')[index].style.display = 'none'
    },
    rowIndex ({ row, rowIndex }) {
      row.rowIndex = rowIndex
    },
    formatter (row) {
      return row.rowIndex + 1
    },
    handleDuration (time) {
      if (time) {
        var timestamp = new Date(new Date().getTime() - time)
        var usedDay = Math.ceil(timestamp / (24 * 3600 * 1000))
        if (usedDay == 1) {
          return this.$t('yhubReport.today');
        } else {
          return usedDay + this.$t('yhubReport.day')
        }
      }
      return '--'
    },
    getreportdetail () {
      reportDetail({
        mcuId: this.mcuId
      }).then(res => {
        console.log('设备详情yhubInfo:', res)
        this.yhubInfo = res.resultModel
        if (this.yhubInfo.batteryCapacity > 1000) {
          this.yhubInfo.batteryCapacity = this.yhubInfo.batteryCapacity / 100
        }
        if (this.yhubInfo.batteryVoltage > 100) {
          this.yhubInfo.batteryVoltage = this.yhubInfo.batteryVoltage / 100
        }

      })
    },
    // 折线图----start
    initChart2 () { // 充放电记录
      var n = []
      var chargeData = []
      var disChargeData = []
      var socData = []

      this.dataSize = 0
      this.chargedAh = 0
      // getDodChargeReportDetail(this.listQuery).then(response => {
      var parmas = {
        mcuId: this.mcuId,
        startDate: this.weekObj.startTime,
        endDate: this.weekObj.endTime
      }

      listChargingDischarging(parmas).then(res => {
        console.log('listChargingDischarging:', res)
        this.fullscreenLoading = false
        this.myChart2.hideLoading()
        this.columnLineNoData = !Boolean(res.resultModel.length)
        // if (!res.resultModel.length) return
        this.tableData = res.resultModel

        this.tableData.forEach((v, i) => {
          if (v.startTime) { v.startTimeRes = v.startTime; v.startTime = getDateAndHour(v.startTime, 'noYear') }
          if (v.endTime) { v.endTimeRes = v.endTime; v.endTime = getDateAndHour(v.endTime, 'noYear') }
          if (v.startAh && v.endAh) v.energy = parseInt(v.endAh - v.startAh)
        })

        const data = res.resultModel
        // if (!data || (data && data.length < 1)) { this.columnLineNoData = true } else { this.columnLineNoData = false }
        // console.log('data-------------', data)
        for (const i in data) {
          var model = data[i]
          // n.push(new Date(model.endTime).Format('dd/MM hh:mm'))
          // n.push(new Date(model.endTime).Format('MM/dd hh:mm'))
          n.push(getDateAndHour(model.endTimeRes, 'noTime'))
          // n.push(new Date((model.endTime).replace(/-/g, '/')).Format('dd/MM hh:mm'))
          if (model.endSoc < 30) {
            socData.push({
              value: this.doubleToInt(model.endSoc), symbolSize: 1,
              itemStyle: {
                normal: {
                  label: {
                    show: true,
                    position: 'left',
                    textStyle: { color: '#D02222', fontSize: 16, fontWeight: 'bold' }
                  }
                }
              }
            })
          } else {
            socData.push(this.doubleToInt(model.endSoc))
          }
          if (this.minSoc > model.endSoc) {
            this.minSoc = this.doubleToInt(model.endSoc)
          }
          // debugger
          if (model.isChargeing) {
            this.dataSize++
            var difference = parseFloat(model.endAh - model.startAh)
            this.chargedAh = this.chargedAh + difference

            if (model.endSoc === 100) {
              chargeData.push({
                value: parseFloat(model.endAh - model.startAh).toFixed(2), symbolSize: 1, tooltip: {
                  formatter: this.myFormat(model)
                }
              })
            } else {
              chargeData.push({
                value: parseFloat(model.endAh - model.startAh).toFixed(2), symbolSize: 1, tooltip: {
                  formatter: this.myFormat(model)
                }
              })
            }
            disChargeData.push('')
          } else {
            disChargeData.push({
              value: parseFloat(model.endAh - model.startAh).toFixed(2), symbolSize: 1, tooltip: {
                formatter: this.myFormat(model)
              }
            })
            chargeData.push('')
          }
        }

        var option2 = {
          tooltip: {
            trigger: 'axis',
            show: true,
            showDelay: 50,
            hideDelay: 50,
            transitionDuration: 0,
            backgroundColor: 'rgba(0,0,0,0.7)',
            borderColor: '#f50',
            borderRadius: 10,
            borderWidth: 0,
            padding: 10,

            textStyle: {
              color: '#F9F7F7',
              decoration: 'none',
              fontFamily: 'Verdana, sans-serif',
              fontSize: 10,
              fontStyle: 'italic'
            }

          },
          legend: {
            data: ['Charged', 'Discharged', 'SOC']
          },

          calculable: true,
          xAxis: [
            {
              type: 'category',
              data: n,
              axisTick: {
                alignWithLabel: true
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              splitLine: {
                show: true
              },
              axisLabel: {
                formatter: '{value} Ah'
              }
            },
            {
              type: 'value',
              name: 'SOC',
              splitLine: {
                show: false
              },
              axisLabel: {
                formatter: '{value} %'
              }
            }
          ],
          color: ['#7fb80e', '#009ad6', '#005344'],
          series: [

            {
              name: 'Charged',
              type: 'bar',
              data: chargeData,
              interval: 20,
              barMaxWidth: 40,
              label: {
                show: true,
                position: 'top',
                formatter: '{c} Ah'
              },
              tooltip: {
                trigger: 'item',
                formatter: '<br/>{a}{b}:{c}Ah'
              }
            },
            {
              name: 'Discharged',
              type: 'bar',
              interval: 20,
              data: disChargeData,
              barMaxWidth: 40,
              label: {
                show: true,
                position: 'top',
                formatter: '{c} Ah'
              },
              tooltip: {
                trigger: 'item',
                formatter: '<br/>{a}{b}:{c}Ah'
              }
            },
            {
              name: 'SOC',
              type: 'line',
              yAxisIndex: 1,
              data: socData,
              itemStyle: { normal: { label: { show: true, position: 'left', formatter: '{c} %' } } }
            }
          ]
        }
        // console.log(option2)
        // if (option2 && typeof option2 === 'object') {
        this.myChart2.setOption(option2, true)
        // console.log('this.myPieChart=====================', myChart2)
        // this.myChart2.on('finished', function () { // 图表渲染完成后
        //   this.jlcgImgBase64 = myChart2.getDataURL()
        //   document.getElementById('chart3').setAttribute('src', this.jlcgImgBase64)
        // })
        // }
        // 记录表格数据
        this.tableChargeData = [...this.tableData]
        let cycles = this.tableChargeData[this.tableChargeData.length - 1].cycles || 0;
        let rowspan = 1;
        for (var i = this.tableChargeData.length - 1; i >= 0; i--) {
          var v = this.tableChargeData[i]
          console.log(cycles + ':' + v.cycles, i + ':' + rowspan)
          if (cycles == v.cycles) {
            rowspan++
          } else {
            this.tableChargeData[i + 1].rowspan = rowspan
            rowspan = 1;
            cycles = v.cycles
          }
          if (i == 0) {
            const aa = this.tableChargeData.filter(item => item.cycles == v.cycles)
            v.rowspan = aa.length
          }

          // 计算时长
          if (v.startTime && v.endTime) {
            v.chargedTime = getDuration(v.endTimeRes - v.startTimeRes)
            // var myTime = v.endTimeRes - v.startTimeRes
            // v.chargedTime = parseInt((myTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) + ' h ' + parseInt((myTime % (1000 * 60 * 60)) / (1000 * 60)) + ' min '
          }
        }

        console.log('表格数据：', this.tableChargeData)

      })
    },
    getOptionsLocal () {
      return [{
        value: '1',
        label: this.$t('detail.yesterday')
      }, {
        value: '2',
        label: this.$t('detail.lastWeek')
      }, {
        value: '3',
        label: this.$t('detail.lastMonth')
      }]
    },
    doubleToInt: function (d) {
      if (d !== null) {
        return Math.round(d)
      } else {
        return 0
      }
    },
    myFormat (params) {
      // console.log('params---', params)
      var str = ''
      if (params.isChargeing) {
        str = '<h2>Charged Info</h2>' +
          'Total Ah:\t' + parseFloat(params.endAh - params.startAh).toFixed(2) + '\tAh' +
          '<br/>Start Time:\t' + getDateAndHour(params.startTimeRes, 'noTime') + '\t\t' + parseFloat(params.startSoc).toFixed(0) + '\t %' +
          '<br/>End Time:\t' + getDateAndHour(params.endTimeRes, 'noTime') + '\t\t' + parseFloat(params.endSoc).toFixed(0) + '\t %' +
          '<br/>Mix.Temp:\t' + parseFloat(params.minTemp / 100).toFixed(0) + '\t℃' +
          '<br/>Max.Temp:\t' + parseFloat(params.maxTemp / 100).toFixed(0) + '\t℃' +
          '<br/>Min.Voltage:\t' + params.minVoltage / 100 + '\tV' +
          '<br/>Max.Voltage:\t' + params.maxVoltage / 100 + '\tV'
      } else {
        str = '<h2>Discharged Info</h2>' +
          'Total Ah:\t' + parseFloat(params.endAh - params.startAh).toFixed(2) + '\tAh' +
          '<br/>Depth of Discharged:\t' + parseFloat(100 - params.endSoc).toFixed(0) + '\t%' +
          '<br/>End Time:\t' + getDateAndHour(params.endTimeRes, 'noTime') + '\t\t' + parseFloat(params.endSoc).toFixed(0) + '\t%' +
          '<br/>Mix.Temp:\t' + parseFloat(params.minTemp / 100).toFixed(0) + '\t℃' +
          '<br/>Max.Temp:\t' + parseFloat(params.maxTemp / 100).toFixed(0) + '\t℃' +
          '<br/>Min.Voltage:\t' + params.minVoltage / 100 + '\tV' +
          '<br/>Max.Voltage:\t' + params.maxVoltage / 100 + '\tV'
      }
      return str
    },
    // 折线图----end

    // 饼状图
    initPieChart (className, arr) {
      var that = this
      setTimeout(() => {
        var myPies = document.getElementsByClassName(className)
        for (var i = 0; i < myPies.length; i++) {
          this.myPieChart = echarts.init(myPies[i])
          var index = i
          var myPieOption = {
            tooltip: { // 提示框
              trigger: 'item',
              formatter: '{b}: {d}%',
              position: function (p) { // 其中p为当前鼠标的位置
                return [p[0] + 10, p[1] - 10]
              },
              textStyle: {
                align: 'left'
              }
            },
            series: [
              {
                type: 'pie',
                radius: '65%',
                center: ['50%', '50%'],
                selectedMode: 'single',
                data: arr[i],
                label: {
                  label: {
                    show: false
                  }
                }
              },
              {
                name: '',
                type: 'pie',
                radius: '85%',
                center: ['50%', '50%'],
                data: [],
                itemStyle: {
                  normal: {
                    label: { // 此处为指示线文字
                      show: true,
                      position: 'inner', // 标签的位置
                      textStyle: {
                        fontWeight: 200,
                        fontSize: 20 // 文字的字体大小
                      },
                      formatter: function (p) { // 指示线对应文字
                        // console.log('p-------------', p)
                        var data = p.data
                        return data
                      }
                    },
                    labelLine: { // 指示线状态
                      show: true,
                      smooth: 0.2,
                      length: 10,
                      length2: 20
                    }
                  }
                }
              }
            ],
            color: ['#a9d252', '#ff8c23', '#019ad6']
          }
          // console.log('arr[i]============', arr[i])
          if (className == 'myPieChartSecond') {
            //   return
            var model = that.odcDailyVoList[index]
            myPieOption.tooltip.formatter = '{b}: {c} Ah' +
              '<br/>Lowest SOC: ' + Math.round(model.minSoc / 100) + ' %' +
              '<br/>Used Rate: ' + model.usedRate + ' %' +
              '<br/>Lowest voltage: ' + model.minVoltage / 100 + ' V' +
              '<br/>Highest temperature: ' + Math.round(model.maxTemprature / 100) + ' ℃'
            // return '充电情况' + '<br/>{a}{b}:{c}Ah '
            myPieOption.color = ['#e2c31d', '#33cccc']
          } else if (className == 'myPieChartFirst') {
            var model = that.odcDailyVoList[index]

          }
          this.myPieChart.setOption(myPieOption, false)
        }
      })
    },
    // 柱状图
    initColumnarChart (id) {
      // console.log(this.datadetail)

      var myColumnar = document.getElementById(id)
      this.myColumnarChart = echarts.init(myColumnar)

      this.myColumnarChart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },

        yAxis: [{
          type: 'value',
          axisTick: {
            show: false
          }
        }],
        series: [{
          name: '数据',
          type: 'bar',
          stack: 'vistors',
          barWidth: '20%',
          data: seriesdataobjct,
          color: ['rgb(255,140,0)', 'rgb(30,144,255)', 'rgb(0,255,0)', 'rgb(30,144,255)', 'rgb(0,255,0)'],
          animationDuration
        }]
      })
    },
    // 饼状图切换
    changePieChart (event, val, index) {
      // 当在监控点击切换的时候，加个延迟主动触发窗口变化，这样窗口改变性能分析页就不会发生图表大小有问题的情况了 【这里的代码是关键！！！】
      setTimeout(() => {
        const triggerResize = new Event('resize')
        window.dispatchEvent(triggerResize)
      }, 0)

      var eventParent = event.target.nodeName == 'SPAN' ? event.target.parentElement.parentElement : event.target.parentElement
      var eventDiv = document.getElementsByClassName('pieChartDiv')[index]
      if (val == 1) {
        eventDiv.firstChild.style.display = 'block'
        eventDiv.lastChild.style.display = 'none'
        eventParent.firstChild.classList.add('active')
        eventParent.lastChild.classList.remove('active')
      } else if (val == 2) {
        eventDiv.firstChild.style.display = 'none'
        eventDiv.lastChild.style.display = 'block'
        eventParent.firstChild.classList.remove('active')
        eventParent.lastChild.classList.add('active')
      }
    },
    
    // 设备情况摘要
    _getOdc () {
      var parmas = {
        mcuId: this.mcuId,
        startDate: this.weekObj.startTime,
        endDate: this.weekObj.endTime
      }
      getOdc(parmas).then(res => {
        console.log('getOdc:', res)
        this.loading = false

        var myRes = JSON.parse(JSON.stringify(res.resultModel))
        myRes.forEach((v, i) => {
          v.monthDay = getDateAndWeek(Number(v.monthDay))
          v.pieSeriesData1 = []
          v.pieSeriesData1.push(
            { value: parseInt(v.chargeTime / 1000) || 0, name: 'CHARGED DURATION', divClass: 'myPieChartFirst' },
            { value: parseInt((86400 - v.usedTime / 1000 - v.chargeTime / 1000)) || 0, name: 'IDLE', divClass: 'myPieChartFirst' },
            { value: parseInt(v.usedTime / 1000) || 0, name: 'USED DURATION', divClass: 'myPieChartFirst' }
          )
          v.pieSeriesData2 = []
          v.pieSeriesData2.push(
            { value: Math.round(v.charedAh / 100), name: 'CHARGED AH', minSoc: v.minSoc, usedRate: v.usedRate, minVoltage: v.minVoltage, maxTemprature: v.maxTemprature, divClass: 'myPieChartSecond' },
            { value: Math.round(v.usedAh / 100), name: 'USED AH', minSoc: v.minSoc, usedRate: v.usedRate, minVoltage: v.minVoltage, maxTemprature: v.maxTemprature, divClass: 'myPieChartSecond' }
          )

        })

        this.odcDailyVoList = res.resultModel
        this.odcDailyVoList.forEach((v) => {
          if (v.monthDay) {
            const lang = this.$i18n.locale
            if (lang == 'zh_CN' || lang == 'zh_HK') {
              v.monthDay = '星期' + '日一二三四五六'.charAt(new Date(Number(v.monthDay)).getDay())
            } else if (lang == 'ja') {
              v.monthDay = ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜'][new Date(Number(v.monthDay)).getDay()]
            } else {
              v.monthDay = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][new Date(Number(v.monthDay)).getDay()]
            }
          }
          
        })

        this.myodcDailyVo = res.resultModel
        this.myodcDailyVo.forEach((v) => {
          var arr = []
          var arr2 = []
          arr.push({ value: parseInt(v.chargeTime / 1000) || 0, name: 'Charged duration' }, { value: parseInt((86400 - v.usedTime / 1000 - v.chargeTime / 1000)) || 0, name: 'Idel duration' }, { value: parseInt(v.usedTime / 1000) || 0, name: 'Used duration' })

          if (v.charedAh && v.usedAh) {
            arr2.push({ value: v.charedAh, name: 'Charged Ah' }, { value: v.usedAh, name: 'Used Ah' })

          }
          this.myPieChartFirstData.push(arr)
          this.myPieChartSecondtData.push(arr2)
        })

        this.myPieChartSecondtData.forEach((v, i) => {
          var model = this.myodcDailyVo[i]
          v.tooltip = {
            formatter: function (params) {
              return '充电情况' + '<br/>{a}{b}:{c}Ah ' +
                '<br/>Start Time:' + timestampformat(model.startTime) + '\t' + model.startSoc + '%' +
                '<br/>End Time::' + timestampformat(model.endTime) + '\t' + model.endSoc + '%' +
                '<br/>Max.Temp.:' + model.maxTemp + '℃' +
                '<br/>Min.Temp.:' + model.minTemp + '℃' +
                '<br/>Max.Voltage:' + model.maxVoltage + 'V' +
                '<br/>Min.Voltage:' + model.minVoltage + 'V'
            }
          }
        })



        this.initPieChart('myPieChartFirst', this.myPieChartFirstData) // 饼状图
        this.initPieChart('myPieChartSecond', this.myPieChartSecondtData) // 饼状图

        

        this.dsl1 = myRes

        this._getHourReport()
      })
    },
    _getHourReport () {
      var parmas = {
        mcuId: this.mcuId,
        startDate: this.weekObj.startTime,
        endDate: this.weekObj.endTime

      }
      getHourReport(parmas).then(response => {
        console.log('getHourReport', response)
        if (response.resultCode == 1001) {

          if (this.dsl1.length > response.resultModel.length) {
            this.dsl1 = this.dsl1.splice(0, response.resultModel.length)
          } else if (this.dsl1.length < response.resultModel.length) {
            response.resultModel = response.resultModel.splice(0, this.dsl1.length)
          }

          this.dsl1.forEach((m, mi) => {

            response.resultModel.forEach((v, vi) => {
              this.dsl1[mi].odcEventDailyVoList1 = JSON.parse(response.resultModel[mi].jsonStr)
            })
          })
          this.summaryList = this.dsl1
          this.$nextTick(() => {
            var arr = document.querySelectorAll('.questionPop')
            arr.forEach(v => {
              v.style.display = 'none'
            })
          })
        }
      })
    },

    // 警告信息
    listWarning2 () {
      var parmas = {

        startDate: this.weekObj.startTime,
        endDate: this.weekObj.endTime,
        key: this.mcuId,
        pageNum: 0, // 分页--选中某一页
        pageSize: 1000 // 分页--每一页的列表的行数 10 20 50

      }
      listWarningPushMsg2(parmas).then(res => { // 警告信息列表数据
        if (res.resultCode === 1001) {

          if (!res.resultModel) { this.warningTableData = []; return }

          this.warningTableData = res.resultModel.list
          for (var i = this.warningTableData.length - 1; i >= 0; i--) {
            var v = this.warningTableData[i]
            v.createTime = getDateAndHour(v.createTime, 'noYear')
            if (v.delFlag == 1) {
              v.updateTime = getDateAndHour(v.updateTime, 'noYear'); v.status = this.$t('warningPage.Solevd')
            } else {
              v.updateTime = '--'; v.status = this.$t('warningPage.Unsolved')
            }
            switch (v.msgType) {
              case 1: {
                if (v.triggerValue) v.triggerValue = v.triggerValue > 100 ? Math.round(v.triggerValue / 100) : Math.round(v.triggerValue)
                v.message = this.$t('warningInfo.batterySocLow1') + v.triggerValue + this.$t(`warningInfo.batterySocLow2`); break
              }
              case 2: v.message = this.$t('warningInfo.batteryWaterLow'); break
              case 4: {
                if (v.triggerValue) v.triggerValue = v.triggerValue > 100 ? Math.round(v.triggerValue / 100) : Math.round(v.triggerValue)
                v.message = this.$t('warningInfo.batteryTemHeight1') + temChangeUnit(v.triggerValue) + this.$t('warningInfo.batteryTemHeight2'); break
              }
              case 5: { v.message = this.$t('warningInfo.batteryCapacity1') + v.triggerValue + this.$t('warningInfo.batteryCapacity2'); break }
              case 6: { v.message = this.$t('warningInfo.batteryNoPosition'); break }
              case 7: { v.message = this.$t('warningInfo.batteryVoltageLow1') + v.triggerValue + this.$t('warningInfo.batteryVoltageLow2'); break }
              case 8: { v.message = this.$t('warningInfo.batteryTemLow1') + temChangeUnit(v.triggerValue) + this.$t('warningInfo.batteryTemLow2'); break }
              case 9: { v.message = this.$t('warningInfo.batteryTemAbnormal'); break }
              case 10: { v.message = this.$t('warningInfo.batteryVoltageHeight1') + v.triggerValue + this.$t('warningInfo.batteryVoltageHeight2'); break }
              case 15: { v.message = this.$t('warningInfo.HalfVWarn'); break }
              case 16: { v.message = this.$t('warningInfo.offlineWarn').replace('$1', v.triggerValue); break }
              case 17: { v.message = this.$t('warningInfo.linChargeOverWarn'); break }
              case 18: {
                if (v.triggerValue) { v.triggerValueZh = getDateAndHour(v.triggerValue, 'noTime') }
                v.message = this.$t('warningInfo.overTiemTo').replace('$1', v.triggerValueZh)
                break
              }
              case 19: { v.message = this.$t('warningInfo.overTiem'); break }
              case 20: { v.message = this.$t('warningSet.chargeDisAbnormalWarn'); break }
              case 21: { v.message = this.$t('warningInfo.unitVLowWarn'); break }
              default: this.warningTableData.splice(i, 1)
            }
          }
        }
      })
    },

    download () {
      this.isShowLogo = true;
      setTimeout(() => {
        this.downloadPdf()
      }, 1000);
      setTimeout(() => {
        this.isShowLogo = false;

      }, 3000);
    },
    downloadPdf () {
      const weekStart = getDateAndHour(this.weekObj.startTime, 'noTime')
      const weekEnd = getDateAndHour(this.weekObj.endTime, 'noTime')
      var title = this.$t('report.WeeklyReport') + this.yhubInfo.deviceName + "_" + weekStart + '_' + weekEnd;
      var dom = document.getElementById("mainContent");  // 生成pdf的html内容
      // console.log(dom.clientWidth, dom.clientHeight)
      html2canvas(dom, {
        allowTaint: true,
        scrollY: 0,
        scrollX: 0,
        useCORS: true, // 开启跨院
        width: dom.clientWidth,
        height: dom.clientHeight
      }).then(function (canvas) {
        // var contentWidth = canvas.width;
        // var contentHeight = canvas.height;
        // var pdfWidth = (contentWidth + 10) / 2 * 0.75;
        // var pdfHeight = (contentHeight + 100) / 2 * 0.75; // 500为底部留白
        // var imgWidth = pdfWidth;
        // var imgHeight = contentHeight / 2 * 0.75; //内容图片这里不需要留白的距离
        // var pageData = canvas.toDataURL("image/jpeg", 1.0);
        // var pdf = new jsPDF("", "pt", [pdfWidth, pdfHeight]);
        // pdf.addImage(pageData, "jpeg", 0, 0, imgWidth, imgHeight);
        // pdf.save(title + ".pdf");
        var contentWidth = dom.clientWidth; // 宽高写死，强制分页
        var contentHeight = dom.clientHeight;
        //一页pdf显示html页面生成的canvas高度;
        var pageHeight = contentWidth / 592.28 * 841.89;
        //未生成pdf的html页面高度
        var leftHeight = contentHeight;
        //页面偏移
        var position = 0;
        //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
        var imgWidth = 595.28;
        var imgHeight = contentHeight / 2; // 为了分页，所以写死。592.28 / contentWidth * contentHeight会导致图片被分割
        var pageData = canvas.toDataURL("image/jpeg", 1.0);
        var pdf = new jsPDF("", "pt", "a4");
        //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
        //当内容未超过pdf一页显示的范围，无需分页
        if (leftHeight < pageHeight) {
          pdf.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
        } else {
          while (leftHeight > 0) {
            //arg3-->距离左边距;arg4-->距离上边距;arg5-->宽度;arg6-->高度
            pdf.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
            leftHeight -= pageHeight;
            position -= 841.89;
            //避免添加空白页
            if (leftHeight > 0) {
              pdf.addPage();
            }
          }
        }
        pdf.save(`${title}.pdf`);

      });
    },
    // 下载周报--pdf
    // downloadPdf2() {
    //   const dom = document.getElementById('mainContent');

    //   html2canvas(dom, { x: 0, y: 0, width: dom.clientWidth, height: dom.clientHeight }).then(canvas => {
    //       const imgData = canvas.toDataURL('image/png');
    //       console.log(imgData)
    //       const pdf = new jsPDF();
    //       pdf.addImage(imgData, 'PNG', 0, 0, dom.clientWidth, dom.clientHeight);
    //       pdf.save("download.pdf");
    //   });
    // },
    // downloadPdf1 () {
    //   // this.showTableCharts = false;
    //   this.isShowLogo = true
    //   document.getElementById('chart2').style.display = 'none'
    //   document.getElementById('chart3').style.display = 'block'
    //   setTimeout(() => {

    //     var headHtml = "<head><style type='text/css' media='print'> @page{ size:  auto;   /* auto is the initial value */margin: 0mm;  /* this affects the margin in the printer settings */}html{/*background-color: #FFFFFF; */margin: 0px;  /* this affects the margin on the html before sending to printer */}</style></head><body>"

    //     var bottHtml = '<p style="height:30px;position:relative;float:right;right:20px;border-top:1px solid block;">' + 'Print Time：' + getDateAndHour(new Date().getTime(), 'noTime') + '</p></body>'

    //     var bdhtml = document.getElementById('mainContent').innerHTML // 获取当前页的html代码

    //     var prnhtml = headHtml + bdhtml + bottHtml // 从结束代码向前取html

    //     // var styleHtml =  " style = '' ";
    //     window.document.body.innerHTML = prnhtml
    //     window.print()
    //     window.document.body.innerHTML = bdhtml
    //     this.$router.go(0)
    //     this.showTableCharts = true
    //   }, 0)
    // }
  }
}
function timestampformat (timestamp) {
  // return (new Date(timestamp)).Format('dd/MM hh:mm')
}
</script>

<style lang="scss" scoped>
.main_content {
  padding: 10px;
  max-width: 1200px;
  margin: 0 auto;
}
.logo_img {
  height: 40px;
  position: absolute;
  left: 20px;
  top: 20px;
}

.questionPop {
  display: inline-block;
  background: white;
  padding: 14px;
  vertical-align: top;
  box-shadow: 1px 1px 5px #ccc;
  position: absolute;
  z-index: 999;
  margin: -140px 0 0 160px;
  width: 80%;
}
.changePie {
  outline: none; //消除默认点击蓝色边框效果
  height: 40px;
  padding: 0 10px;
  font-size: 14px;
  border-radius: 10px;
  border: 1px solid #c2e7b0;
  background: #f0f9eb;
}
.changePie:nth-of-type(1) {
  margin-right: 10px;
}
.active {
  border: 1px solid #67c23a;
  background: #67c23a;
  color: white;
}
.changePieBtn {
  outline: none; //消除默认点击蓝色边框效果
  height: 25px;
  padding: 0 10px;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid #c2e7b0;
  background: #f0f9eb;
  margin-bottom: 10px;
  position: relative;
}
.changePieBtn:nth-of-type(1) {
  // margin-right:10px;
  margin-left: calc(1% + 5px);
}
.active {
  border: 1px solid #67c23a;
  background: #67c23a;
  color: white;
}
.bgBigDiv {
  width: 20px;
  height: 20px;
  margin-top: 3px;
  background: #a9d252;
  display: inline-block;
}
.bgSmallDiv {
  display: inline-block;
  width: 15px;
  height: 15px;
  margin-bottom: -5px;
  margin-left: -13px;
  background: #a9d252;
  border: 1px solid white;
}
.content-wrap {
  position: relative;
  background-color: white;
  border: 2px solid #eaeaea;
  border-radius: 6px;
  padding: 10px 24px 60px;
  margin-bottom: 10px;
}
.chart-wrapper {
  background: #fff;
  padding: 12px 12px 0;
  margin-bottom: 32px;
  position: relative;
}
.overhiden {
  overflow: hidden;
}
.new-member-label {
  background: #fdf1d4;
  padding: 0px 18px;
  border: 1px solid #f8c959;
  border-radius: 5px;
  margin-bottom: 10px;
}
.flex-tips {
  display: inline;
  font-size: 14px;
  color: #666666;
  line-height: 32px;
  width: 100%;
}
.leftcontent {
  width: 20px;
  height: 100%;
  border-radius: 5px;
  margin: 0;
}
.color1 {
  background: #99cc66;
}
.color2 {
  background: #ffcc99;
}
.color3 {
  background: #9999cc;
}
.color4 {
  background: #607d8b;
}
.color5 {
  background: #cc99cc;
}
.color6 {
  background: #6699ff;
}

.topdiv {
  list-style: none;
  padding-bottom: 5px;
  margin: 0;
  padding-left: 0;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-flow: row wrap;
  word-wrap: break-word;
  word-break: break-all;
  // padding: 0;
  //overflow:hidden
}
.lidiv {
  width: 30%;
  margin-right: 3%;
  margin-bottom: 20px;
  height: 120px;
  border-radius: 5px;
  display: flex;
  flex-flow: row;
  border-right: 4px solid #eaeaea;
  border-bottom: 4px solid #eaeaea;
}
.rightconment {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column wrap;
  .right-tiltle {
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 2px;
    font-family: Arial;
  }
  .rignt-percent {
    font-size: 20px;
    font-family: Arial;
  }
}
.top {
  text-align: center;
  .top_title {
    font-size: 20px;
    font-weight: 700;
    padding-top: 10px;
  }
  .datetime {
    font-size: 14px;
    color: #cec1c1;
  }
  .dv1 {
    // width: 427px;
    // color: black;
    // height: 45px;
    position: relative;
    margin: 10px auto;
    font-size: 14px;
    // font-weight: 700;
    .liner {
      width: 70px;
      height: 1px;
      background-color: #ccc;
      margin: 0 10px;
      // position: relative;
      // top: -50%;
    }
    // .dv2 {
    //   text-align: center;
    //   width: 310px;
    //   height: 24px;
    //   font-size: 18px;
    //   line-height: 22px;
    //   margin: 0 auto;
    //   background-color: #fff;
    //   position: relative;
    //   z-index: 3;
    //   color: #606266;
    //   cursor: pointer;
    // }
  }
}

.member-info {
  min-height: 40px;
  line-height: 1.2rem;
  padding: 5px 10px 5px 0;
  overflow: hidden;
  min-width: 210px;
  white-space: nowrap;
  text-overflow: ellipsis;
  .info-name {
    display: inline-block;
    text-align: left;
  }
}

.pane_title {
  height: 40px;
  line-height: 40px;
  text-align: left;
  color: black;
  border-bottom: 1px solid #ccc;
  //margin: 0 20px;
}
.pane_content {
  margin: 0px 0;
}
.rfm-table {
  width: 100%;
  margin: 10px auto;
  border-collapse: collapse;
  text-align: center;
  background-color: #f9fafc;
  tr {
    line-height: 1em;
    td {
      // width: 14.3%;
      padding: 8px 0;
      border: 1px solid #e7ebf3;
      &:first-of-type {
        width: 14.3%;
        // font-weight: bold;
      }
      .primary {
        font-size: 1.1em;
      }
      .sub {
        margin-top: 5px;
        font-size: 0.8em;
      }
    }
  }
}
.downBtn {
  background: #019ad6;
  display: inline-block;
  border-radius: 8px;
  padding: 10px 20px;
  color: white;
  position: absolute;
  right: 30px;
  top: 20px;
  cursor: pointer;
}
</style>
